export default __webpack_public_path__ + "static/media/logo-light.96c274da.svg";